import React from 'react';
import { useContactDealer, DOMAIN_CASES } from 'site-modules/shared/components/inventory/contact-dealer/contact-dealer';
import { DealerOverview } from 'site-modules/shared/components/inventory/contact-dealer/dealer-overview/dealer-overview';
import { RETAIL_CTA_TYPES } from 'site-modules/shared/components/inventory/contact-dealer/constants';

export function DigitalRetailOverview() {
  const { domainCase, isTopEmbeddedLeadFormEnabled, isEmbeddedCarcode, isTED6504Enabled } = useContactDealer();

  if (domainCase === DOMAIN_CASES.BOL_VLA) {
    return (
      <DealerOverview>
        <div className="border-top mt-1_5 pt-1_5">
          <DealerOverview.FiveStar />
          <DealerOverview.Location />

          {isTopEmbeddedLeadFormEnabled ? (
            <div className="d-flex align-items-baseline gap-0_75 mt-0_75">
              {!isEmbeddedCarcode && <DealerOverview.Phone />}
              <DealerOverview.Delivery />
            </div>
          ) : (
            <>
              <DealerOverview.Delivery />
              <DealerOverview.Phone />
            </>
          )}
        </div>
      </DealerOverview>
    );
  }

  const shouldShowOffers = !isTED6504Enabled;

  return (
    <DealerOverview>
      <DealerOverview.RetailerPanel
        showOffersList={shouldShowOffers}
        showDeliveryButton={shouldShowOffers}
        topCtaType={shouldShowOffers ? RETAIL_CTA_TYPES.PHONE : RETAIL_CTA_TYPES.LINK}
      />
    </DealerOverview>
  );
}
